'use strict';
(function () {
  angular.module('pentaApp').factory('clubLogHistory.modal', factory);
  factory.$inject = ['bottomModal.factory'];
  function factory(bottomModal) {
    return bottomModal.create({
      controller: controller,
      templateUrl: 'newClub/modals/clubLogHistory/clubLogHistory.modal.jade',
    });
  }

  controller.$inject = ['$scope', 'modal', 'data'];
  function controller($scope, modal, data) {

    $scope.close = function () {
      modal.close();
    };

    init();
    ///////////////////////
    function init() {
      $scope.rules = data && data.rules;
      $scope.title = i18next.t('Historial de puntos');
      if (!data || !data.clubLogs || !data.clubLogs.length) $scope.list = [];
      $scope.list = processLogs(data.clubLogs);
    }

    function processLogs(clubLogs) {
      if (!clubLogs || !clubLogs.length) return [];
      var green = '#00A756';
      var red = '#FE2113';
      var list = [];
      clubLogs.forEach(function (clubLog) {
        if (!clubLog || !clubLog.clubRule || !clubLog.clubRule.direction || !clubLog.clubRule.name) return;
        var obj = {};
        if (clubLog.clubRule.direction === 'IN') {
          if (clubLog.clubRule.amountType) obj.value = '+' + (clubLog.clubRule.amountType === 'FIXED' ? clubLog.clubRule.amount : clubLog.clubRule.amount * 100 + '%');
          obj.valueStyle = { color: green };
        } else if (clubLog.clubRule.direction === 'OUT') {
          if (clubLog.clubRule.amountType) obj.value = '-' + (clubLog.clubRule.amountType === 'FIXED' ? clubLog.clubRule.amount : clubLog.clubRule.amount * 100 + '%');
          obj.valueStyle = { color: red };
        } else return;
        obj.label = clubLog.clubRule.name;
        obj.date = clubLog.ts;
        list.push(obj);
      });
      return list;
    }

  }
})();
